import {Money} from "../money";

export class WspayFormRequest {
  constructor(
    private customerFirstName?: string,
    private customerLastName?: string,
    private customerAddress?: string,
    private customerCity?: string,
    private customerZIP?: string,
    private customerCountry?: string,
    private customerPhone?: string,
    private customerEmail?: string,
    private amount?: Money,
    private raceId?: number,
    private competitorId?: number) {
  }
}
